exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".analisi-table {\n\tmax-height: 600px;\n\toverflow-y: auto;\n}\n\n.analisi-percent {\n\tcolor: gray;\n\tfont-size: 9pt;\n}\n\n/* i grafici a barre non mantengono le proporzioni: il canvas deve occupare l'altezza del contenitore */\n.analisi-chart /deep/ p-chart,\n.analisi-chart /deep/ p-chart > div {\n\tdisplay: block;\n\theight: 100%;\n}\n\n.analisi-info {\n\tcursor: help;\n\tcolor: #9fd3f0;\n\tmargin-left: 4px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/analisi-ticket/analisi-ticket.component.css
// module id = 313
// module chunks = 0